import { defineMessages } from 'react-intl';

export const billingAttemptsMessages = defineMessages({
    billingAttempts: { id: 'billing-attempts', defaultMessage: 'Billing attempts' },
    billingAttempt: { id: 'billing-attempt', defaultMessage: 'Billing attempt' },
    succeeded: { id: 'billing-attempt-succeeded', defaultMessage: 'Succeeded' },
    failed: { id: 'billing-attempt-failed', defaultMessage: 'Failed' },
    skipped: { id: 'billing-attempt-skipped', defaultMessage: 'Skipped' },
    errorCode: { id: 'error-code', defaultMessage: 'Reason' },
    billingPeriodStart: { id: 'billing-period-start-attempt', defaultMessage: 'Billing period start' },
    retry: { id: 'retry-billing-attempt', defaultMessage: 'Retry' },
    retrySuccess: { id: 'retry-billing-attempt-success', defaultMessage: 'Retried' },
    retrySuccessDescription: {
        id: 'retry-billing-attempt-success-description',
        defaultMessage: 'The unit of work was re-run. Check its new status.',
    },
    retryNothingToDo: { id: 'retry-billing-attempt-nothing', defaultMessage: 'Nothing to retry' },
    retryNothingToDoDescription: {
        id: 'retry-billing-attempt-nothing-description',
        defaultMessage: 'This item is no longer due, so the original attempt was returned unchanged.',
    },
    noBillingPolicy: {
        id: 'error-no-billing-policy',
        defaultMessage: 'The item has no billing policy covering that date.',
    },
    noPricingPolicy: {
        id: 'error-no-pricing-policy',
        defaultMessage: 'The item has no pricing policy at the period start.',
    },
    alreadyCharged: {
        id: 'error-already-charged',
        defaultMessage: 'Skipped - a charge already exists for this period.',
    },
    noBillingEntity: { id: 'error-no-billing-entity', defaultMessage: 'No supplier is configured for the tenant.' },
    noAccountingRange: { id: 'error-no-accounting-range', defaultMessage: 'No automatic numbering range is set up.' },
    noAccountingHeading: { id: 'error-no-accounting-heading', defaultMessage: 'No accounting heading is set up.' },
    noUnit: { id: 'error-no-unit', defaultMessage: 'The global fallback unit is missing.' },
    noTaxReason: { id: 'error-no-tax-reason', defaultMessage: 'The global fallback tax reason is missing.' },
    negativeDocumentTotal: {
        id: 'error-negative-document-total',
        defaultMessage: 'The period nets negative - a credit note is needed.',
    },
    unexpectedError: { id: 'error-unexpected', defaultMessage: 'Unexpected error - see the detail.' },
    billingWorkInProgressError: {
        id: 'custom-error:billing_work_in_progress',
        defaultMessage:
            'This subscription or customer is being billed right now. Retry once the current run has finished.',
    },
});
